// extracted by mini-css-extract-plugin
export default {"resizable-handle":"resizable_resizable-handle__cmVSY"};